import { lazy, Suspense } from 'react';
import PropTypes from 'prop-types';
import { LoadingComponent } from '../../../components/global/LoadingComponent';
import { ErrorBoundary } from 'dibs-error-tools/ErrorBoundary';

const PdpSharedShippingModalLazy = lazy(() =>
    import(
        /* webpackChunkName: "PdpSharedShippingModal" */
        './PdpSharedShippingModal'
    ).then(({ PdpSharedShippingModal }) => ({ default: PdpSharedShippingModal }))
);

function PdpSharedShippingModalLoader(props) {
    if (!props.isOpened) {
        return null;
    }
    return (
        <ErrorBoundary fallback={() => null}>
            <Suspense fallback={<LoadingComponent />}>
                <PdpSharedShippingModalLazy {...props} />
            </Suspense>
        </ErrorBoundary>
    );
}

PdpSharedShippingModalLoader.propTypes = {
    currency: PropTypes.string,
    itemId: PropTypes.string.isRequired,
    userId: PropTypes.string,
    environment: PropTypes.object.isRequired,

    showDetails: PropTypes.bool,
    isOpened: PropTypes.bool.isRequired,
    closeShippingModal: PropTypes.func.isRequired,
    itemQuantity: PropTypes.number,
};

export { PdpSharedShippingModalLoader };
